export const PROFESSIONAL_GROUPS = 'professional'
export const USER_GROUPS = 'user'
export const CONFIRM_CLASS = 'confirm-associated'
